<template>
  <div class="Portfolio">
    <Tabs
      :content="tabs"
      :wait="waitAll"
      :selectedTab="selectedTab"
      :timeout="500"
      @getCurrentTab="setTab"
    />
    <v-layout wrap class="pa-2">
      <v-flex xs12 sm6 md3>
        <doughnut-card :plants="selectedPlants">
          <template #title>
            <span class="d-flex a-title card-title">
              {{ selectedGroup ? selectedGroup.title : "Geral" }}
            </span>
          </template>
        </doughnut-card>
      </v-flex>

      <v-flex
        xs12
        sm6
        md3
        lg2
        :class="$vuetify.breakpoint.smAndDown ? 'mt-2' : 'pl-2 pr-2'"
        class="pl-sm-2 positionIpad"
      >
        <div class="total-card-grid " :style="responsiveGrid">
          <TotalCard :plants="selectedPlants" />
          <CardAlarms
            v-if="showAlarms"
            :reference="selectedGroup"
            class="mt-2"
            :plantsId="plantsId"
          />
        </div>
      </v-flex>
      <v-flex xs12 sm12 md6 lg7 :class="$vuetify.breakpoint.smAndDown ? 'pt-2' : ''">
        <GraphCard :plants="selectedPlants" />
      </v-flex>
      <v-flex xs12 sm12 md12 :class="$vuetify.breakpoint.xsOnly ? 'paddingMonitor' : ''">
        <PlantsMonitor :plants="plantsSelection" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { getPlants } from "@/models/Plant.js";
import { getComponent } from "@/models/Component.js";
import { getCurrentUserGroups } from "@/models/AccessGroup";

import Tabs from "@/components/Tabs/Tabs";
import DoughnutCard from "./DoughnutCard/Index.vue";
import TotalCard from "./TotalCard/Index.vue";
import GraphCard from "./GraphCard/GraphCard.vue";
import PlantsMonitor from "./PlantsMonitor/PlantsMonitor.vue";
import CardAlarms from "@/components/Alarms/CardAlarms.vue";

import Loader from "@/components/Loaders/FullscreenLoader";
import { SourceToken } from "@/utils/Axios/CancelToken";
import { mapGetters } from "vuex";
export default {
  components: {
    DoughnutCard,
    TotalCard,
    GraphCard,
    PlantsMonitor,
    Tabs,
    Loader,
    CardAlarms,
  },
  mixins: [SourceToken],
  data() {
    return {
      plants: [],
      selectedPlants: [],
      groups: [],
      response: undefined,
      tabs: [],
      selectedGroup: undefined,
      firstTime: true,
      waitAll: true,
      waitCOG: true,
      waitMTD: true,
      waitYTD: true,
      waitMonitor: true,
      selectedTab: 0,
      tabsComponent: [],
      options: {
        keys: "keys",
        titles: "titles",
      },
    };
  },
  props: {
    type: String,
  },
  created() {
    this.fetchData();
    this.getShowAlarms();
  },
  computed: {
    ...mapGetters(["showAlarms"]),
    plantsId() {
      if (this.plants) {
        return [...this.plants.map((e) => e.id)];
      }
      return [];
    },
    plantsSelection() {
      if (this.plants.length && this.selectedPlants.length) {
        return this.plants.filter((e) => this.selectedPlants.includes(e.id));
      }
      return [];
    },
    responsiveGrid() {
      return { gridTemplateRows: this.showAlarms ? "0.7fr 0.3fr" : "1fr" };
    },
  },
  methods: {
    freeTab(response) {
      switch (response.component) {
        case "COG":
          this.waitCOG = response.val;
          break;
        case "MTD":
          this.waitMTD = response.val;
          break;
        case "YTD":
          this.waitYTD = response.val;
          break;
        case "Monitor":
          this.waitMonitor = response.val;
          break;
      }
      this.waitAll = this.waitCOG || this.waitMTD || this.waitYTD || this.waitMonitor;
      if (!this.waitAll) {
        for (let i = 0; i < this.tabs.length; i++) {
          const tab = this.tabs[i];
          if (tab.key == this.type && this.firstTime) {
            this.selectedTab = i;
            this.setTab(tab);
            this.firstTime = false;
          }
        }
      }
    },
    async fetchData() {
      this.plants = await getPlants();
      this.selectedPlants = this.plantsId;
      this.tabsComponent = await getComponent({
        featureName: "Portfolio",
        name: "Tabs",
      });
      await this.tabsComponent.setSpecific();
      this.groups = await getCurrentUserGroups();
      this.buildTabs();
      this.waitAll = false;
    },
    buildTabs() {
      let tabs = [{ key: "all", title: "Geral", plantsId: [] }];
      this.groups.forEach(({ name, description, plantsId }) => {
        tabs.push({ key: name, title: description, plantsId });
      });
      this.tabs = tabs;
    },
    setTab(object) {
      this.selectedGroup = object;
      const { plantsId } = object;
      if (plantsId.length) {
        this.selectedPlants = object.plantsId;
      } else {
        this.selectedPlants = this.plantsId;
      }
    },
    async getShowAlarms() {
      let component = await getComponent({ name: "Alarms", feature_name: "Alarms" });
      if (component) this.$store.dispatch("setShowAlarms");
    },
  },
};
</script>

<style scoped lang="css">
.Portfolio {
  width: 100%;
}
.paddingMobile {
  margin: 15px 10px;
}
.paddingDesktop {
  margin: 20px 25px;
}
.box {
  padding: 0px 5px 5px 5px;
}
.Monitor {
  margin: 0 auto;
}

@media only screen and (min-width: 992px) {
  .paddingTable {
    padding: 1px 0px 0px 0px;
  }
}

@media only screen and (max-width: 600px) {
  .spacingMobile {
    margin-top: 10px;
  }
}
.card-title {
  margin-bottom: 21px;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1023px) {
  .positionIpad {
    margin-top: -7px;
    padding-bottom: 7px;
  }
}
.total-card-grid {
  height: 100%;
  display: grid;
}

.paddingMonitor{
  padding-top: 9px;
}
</style>
